import React, { useEffect, useState } from "react";

import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.js";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, Tooltip } from "@material-ui/core";
import classNames from "classnames";

import get from "lib/requests";
import {
	ErrorMessage,
	LoadingMgs,
	SuccessMessage,
} from "components/Common/toastify";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import AccountAddDialog from "./AccountAddDialog.js";
// @material-ui/core icons
import Loading from "components/Common/loading";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import SubscriptionUpdateDialog from "./SubscriptionUpdateDialog";
import { setDashboard } from "redux/ducks/CSPDashboardSlice";
import { setSubscription } from "redux/ducks/subscriptionSlice";
import { useNavigate } from "react-router-dom";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { post } from "lib/requests";
import {
	PersonAdd,
	Receipt,
	Visibility,
	VisibilityOff,
} from "@material-ui/icons";
import EmailPreview from "./EmailPreview.js";
import SubscriptionReportDialog from "./SubscriptionReportDialog.js";

const useStyles2 = makeStyles(headersStyle);
const useStyles = makeStyles(style);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const SubscriptionDetails = () => {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const classes = useStyles();
	const [subscriptionIdShowHide, setSubscriptionIdShowHide] = useState(false);
	const navigate = useNavigate();
	const account = useSelector((state) => state.account);
	const userDetails = useSelector((state) => state.user);
	const customer = useSelector((state) => state.customer);
	const [loading, setLoading] = useState(false);

	const hideShowColumn = () => {
		return (
			<div>
				Subscription Id &nbsp;
				{subscriptionIdShowHide ? (
					<Visibility
						className={classesCSStyles?.buttonIcon}
						onClick={() => {
							subscriptionToggle();
						}}
					/>
				) : (
					<VisibilityOff
						className={classesCSStyles?.buttonIcon}
						onClick={() => {
							subscriptionToggle();
						}}
					/>
				)}
			</div>
		);
	};

	const subscriptionToggle = () => {
		setSubscriptionIdShowHide(!subscriptionIdShowHide);
	};

	const [tableHeader, setTableHeader] = useState([
		"Name",
		hideShowColumn(),
		"Purchased",
		"Next Billing Date",
		"Renewal Date",
		"Billing Frequency",
		"Term",
		"Auto Renew",
		"Status",
		"Action",
	]);

	useEffect(() => {
		if (subscriptionData) {
			if (subscriptionData?.directcustomer) {
				setTableHeader([
					"Name",
					hideShowColumn(),
					"Purchased",
					"Next Billing Date",
					"Renewal Date",
					"Billing Frequency",
					"Term",
					"Auto Renew",
					"Status",
					"Action",
				]);
			} else {
				setTableHeader([
					"Name",
					hideShowColumn(),
					"Purchased",
					"Next Billing Date",
					"Renewal Date",
					"BILLING FREQUENCY",
					"Term",
					"Auto Renew",
					"Status",
					"Reseller Cost",
					"Action",
				]);
			}
		}
	}, [subscriptionIdShowHide]);

	const dispatch = useDispatch();
	const classes2 = useStyles2();

	const [moreInfo, setMoreInfo] = useState(false);
	const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);
	const [subscriptionData, setSubscriptionData] = useState(null);
	const [subscriptionList, setSubscriptionList] = useState([]);

	const [accountAddDialog, setAccountAddDialog] = useState(false);
	const [subscriptionReportDialog, setSubscriptionReportDialog] = useState(
		false
	);
	const [emailPreview, setEmailPreview] = useState(false);
	const [emailPreviewData, setEmailPreviewData] = useState(null);

	const [showHide, setShowHide] = useState(true);
	const useBaseData = {
		list: [],
		reportfor: "",
		billingcycle: "",
	};
	const [usageBasedSubscriptionList, setUsageBasedSubscriptionList] = useState(
		useBaseData
	);

	const customerDetails = useSelector((state) => state.customer);

	useEffect(() => {
		if (customerDetails?.tenantId) geSubscriptionsData();
		return function cleanup() {};
	}, [customerDetails]);

	const geSubscriptionsData = async () => {
		setLoading(true);
		try {
			await get(`/api/customer/subscriptions/${customerDetails?.tenantId}`, true)
				.then((res) => {
					if (res.data.success) {
						const subscriptionData_ = res.data.records;

						setSubscriptionData(subscriptionData_);
						if (subscriptionData_?.subscriptions?.length != 0)
							setSubscriptionList(subscriptionData_?.subscriptions);
						else setSubscriptionList([]);

						if (subscriptionData_.azuresubscriptions.length != 0)
							setUsageBasedSubscriptionList(subscriptionData_.azuresubscriptions);
						else setUsageBasedSubscriptionList(useBaseData);

						const subUpdate = subscriptionData_?.subscriptions?.map((item) => {
							const itemId = item?.id;
							if (item?.directcustomer) {
								const priceElement = document.getElementById("price_" + itemId);
								const percentageElement = document.getElementById(
									"percentage_" + itemId
								);
								if (priceElement) {
									priceElement.value = item?.enduserprice;
								}
								if (percentageElement) {
									percentageElement.value = item?.percentage;
								}
							}
						});

						if (!subscriptionData_?.directcustomer) {
							setTableHeader([
								"Name",
								hideShowColumn(),
								"Purchased",
								"Next Billing Date",
								"Renewal Date",
								"Billing Frequency",
								"Term",
								"Auto Renew",
								"Status",
								"Reseller Cost",
								"Action",
							]);
						}
					} else {
						setSubscriptionData(null);
						setSubscriptionList([]);
						setUsageBasedSubscriptionList(useBaseData);
						ErrorMessage("Account Details", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Account Details", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Account Details", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const fillButtons = (item) => {
		return (
			<div>
				{userDetails?.canaddeditdelete && (
					<div className="flex">
						<button
							onClick={() => {
								dispatch(setSubscription(item));
								setSubscriptionDialogOpen(true);
							}}
							className={classesCSStyles?.buttonPrimary}>
							Edit
						</button>
						<button
							onClick={() => {
								dispatch(setSubscription(item));
								navigate("/upgrade-subscription");
							}}
							className={classesCSStyles?.buttonPrimary}>
							Upgrade
						</button>
					</div>
				)}

				{item.scheduledNextTermInstructions && (
					<div className="flex">
						<button className={classesCSStyles?.subscriptionUpgrade}>
							Scheduled changes for next renewal Quantity:{" "}
							{item.scheduledNextTermInstructions?.quantity}
						</button>
					</div>
				)}
			</div>
		);
	};

	const extractUSAGE_BASED = (usageBasedSubscriptionList_) => {
		let usageBasedSubscriptionList = [];
		if (usageBasedSubscriptionList_) {
			usageBasedSubscriptionList = usageBasedSubscriptionList_?.map((item) => {
				return [item.offerName, item.quantity];
			});
		}
		return usageBasedSubscriptionList;
	};

	const extractLICENSE_BASED = (licenseBasedSubscriptionList_) => {
		let licenseBasedSubscriptionList = [];

		if (licenseBasedSubscriptionList_) {
			licenseBasedSubscriptionList = licenseBasedSubscriptionList_?.flatMap(
				(item) => {
					let baseRow = [
						item.offerName,
						prepareId(item.id),
						item.quantity,
						item.NextBillingDate,
						item.ExpiryDate,
						item.billingCycle === "monthly" ? "Monthly" : "Annual",
						item.termDuration == "P1Y" ? "Annual" : "Monthly",
						item.autoRenewEnabled === true ? "Yes" : "No",
						item.status.toUpperCase() + " " + (item.nceitem ? "" : ", Legacy"),
						fillButtons(item),
					];

					if (!item.directcustomer) {
						baseRow = [
							item.offerName,
							prepareId(item.id),
							item.quantity,
							item.NextBillingDate,
							item.ExpiryDate,
							item.billingCycle === "monthly" ? "Monthly" : "Annual",
							item.termDuration == "P1Y" ? "Annual" : "Monthly",
							item.autoRenewEnabled === true ? "Yes" : "No",
							item.status.toUpperCase() + " " + (item.nceitem ? "" : ", Legacy"),
							`$${item.realprice}`,
							fillButtons(item),
						];
					}

					// Start with the normal row
					const rows = [baseRow];

					if (item.directcustomer && moreInfo) {
						const extraRow1 = [
							"",
							yourCostColumn(item),
							endUserPriceColumn(item),
							commissionColumn(item),
							endUserUnitPriceColumn(item),
							endUserUnitPercentageColumn(item),
							"",
							"",
							"",
							"",
							"",
						];
						rows.push(extraRow1);
					}

					return rows;
				}
			);
		}
		return licenseBasedSubscriptionList;
	};

	const prepareId = (id_) => {
		const id = id_?.split("-").slice(-1)[0];
		return subscriptionIdShowHide ? id_ : id;
	};

	const addNewSubscription = () => {
		const dashboardData = {
			Heading: "Microsoft 365",
			TeamT5Form: false,
			KinetixForm: false,
			CustomerSubscriptionDetails: false,
			AddCustomerSubscription: true,
			selectedDialogData: null,
			ConfirmOrder: false,
			OrderSummary: false,
		};
		dispatch(setDashboard(dashboardData));
	};

	const endUserUnitPriceColumn = (item) => {
		return (
			item.directcustomer && (
				<div className={classNames(classesCSStyles?.my5, classesCSStyles?.labelAc)}>
					End User Unit Price:
					<CustomInput
						inputProps={{
							disabled: userDetails?.canaddeditdelete ? false : true,
							id: `price_${item?.id}`,
							placeholder: "Enter unit price",
							type: "number",
							defaultValue: item?.enduserprice,
							onChange: (e) => {
								if (e.key === "-" || e.key === "e" || e.target.value < 0) {
									e.target.value = 0;
									e.preventDefault();
									return;
								}
							},
							onBlur: () => {
								changePercentage("price", item);
							},
						}}
						formControlProps={{
							fullWidth: false,
							className: classes2.formControl,
						}}
					/>
				</div>
			)
		);
	};

	const endUserUnitPercentageColumn = (item) => {
		return (
			item.directcustomer && (
				<div className={classNames(classesCSStyles?.my5, classesCSStyles?.labelAc)}>
					End User Percentage:
					<CustomInput
						inputProps={{
							disabled: userDetails?.canaddeditdelete ? false : true,
							id: `percentage_${item?.id}`,
							placeholder: "Enter percentage",
							type: "number",
							defaultValue: item?.percentage,
							onChange: (e) => {
								if (e.key === "-" || e.key === "e" || e.target.value < 0) {
									e.target.value = 0;
									e.preventDefault();
									return;
								}
							},
							onBlur: () => changePercentage("percentage", item),
						}}
						formControlProps={{
							fullWidth: false,
							className: classes2.formControl,
						}}
					/>
				</div>
			)
		);
	};

	const yourCostColumn = (item) => {
		return (
			item.directcustomer && (
				<div className={classNames(classesCSStyles?.my5, classesCSStyles?.labelAc)}>
					Your Cost: ${item?.yourcost}
				</div>
			)
		);
	};

	const endUserPriceColumn = (item) => {
		return (
			item.directcustomer && (
				<div className={classNames(classesCSStyles?.my5, classesCSStyles?.labelAc)}>
					End User Price: ${item?.enduser}
				</div>
			)
		);
	};

	const commissionColumn = (item) => {
		return (
			item.directcustomer && (
				<div className={classNames(classesCSStyles?.my5, classesCSStyles?.labelAc)}>
					Commission: ${item?.commision}
				</div>
			)
		);
	};

	const changePercentage = async (type, item) => {
		try {
			const formField = {};

			formField.id = item?.percentage_id;
			formField.quantity = item?.quantity;

			if (type === "price") {
				formField.field_name = "price";
				formField.field_value = document.getElementById("price_" + item?.id).value;
			} else {
				formField.field_name = "percentage";
				formField.field_value = document.getElementById(
					"percentage_" + item?.id
				).value;
			}

			setLoading(true);
			LoadingMgs("Subscription Update", "processing...");
			await post(
				`/api/subscription/changepercentage/${customerDetails?.tenantId}`,
				formField,
				true
			)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage(
							"Subscription Update",
							"Subscription updated successfully"
						);
						const subscriptionItem = res.data.records.subscription;
						// update setSubscriptionList

						const updatedSubscriptionList = subscriptionList.map((sub) => {
							if (sub.id === item.id) {
								const priceElement = document.getElementById("price_" + item.id);
								const percentageElement = document.getElementById(
									"percentage_" + item.id
								);

								if (priceElement) {
									priceElement.value = subscriptionItem?.enduser_unitprice;
								}
								if (percentageElement) {
									percentageElement.value = subscriptionItem.percentage;
								}
								return {
									...sub,
									commision: subscriptionItem.comission,
									enduserprice: subscriptionItem.enduser_unitprice,
									enduser: subscriptionItem.enduserprice,
									percentage: subscriptionItem.percentage,
								};
							}
							return sub;
						});
						setSubscriptionList(updatedSubscriptionList);
						// geSubscriptionsData();
					} else {
						ErrorMessage("Subscription Update", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Subscription Update", message);
					setLoading(false);
				});
		} catch (error) {
			console.log(error, "error");
			ErrorMessage("Subscription Update", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	return (
		<>
			<div>
				<GridContainer>
					<GridItem xs={12} sm={6} md={6}>
						<div className={classesCSStyles.companyTitle}>
							{customer?.companyName}{" "}
							<span className={classesCSStyles.companyStatus}>
								({customer?.cansubscribe ? "Active" : "In-Active"})
							</span>
						</div>
					</GridItem>
					<GridItem xs={12} sm={6} md={6}>
						<div className={classesCSStyles.alignDiv}>
							<Tooltip
								id="tooltip-tina"
								title="Accounts"
								placement="top"
								classes={{ tooltip: classes.tooltip }}>
								<button
									className={classesCSStyles?.buttonPrimary}
									onClick={() => {
										window.location.href = "/csp-dashboard";
									}}>
									$ &nbsp; Accounts
								</button>
							</Tooltip>
							{userDetails?.canaddeditdelete && (
								<Tooltip
									id="tooltip-tina"
									title="Add New Customer"
									placement="top"
									classes={{ tooltip: classes.tooltip }}>
									<button
										className={classesCSStyles?.buttonPrimary}
										onClick={() => {
											setAccountAddDialog(true);
										}}>
										<PersonAdd className={classesCSStyles?.buttonIcon} /> &nbsp; Add New
									</button>
								</Tooltip>
							)}
							<Tooltip
								id="tooltip-tina"
								title="Subscription Reports"
								placement="top"
								classes={{ tooltip: classes.tooltip }}>
								<button
									className={classesCSStyles?.buttonPrimary}
									onClick={() => {
										setSubscriptionReportDialog(true);
									}}>
									<Receipt className={classesCSStyles?.buttonIcon} /> &nbsp; Report
								</button>
							</Tooltip>
						</div>
					</GridItem>
				</GridContainer>
			</div>
			<div className={classNames(classesCSStyles.mx5, classesCSStyles.my20)}>
				<Card
					className={classNames(
						classesCSStyles.px5,
						classesCSStyles.my5,
						classesCSStyles.minHeight
					)}>
					<CardHeader color="info">
						<GridContainer>
							<GridItem xs={12} sm={6} md={6}>
								<h4 className={classesCSStyles?.cartLabel}>Subscription Details</h4>
							</GridItem>
							<GridItem xs={12} sm={6} md={6} className={classesCSStyles.alignRight}>
								<div className={classesCSStyles?.editBtns}>
									<div
										onClick={() => {
											setShowHide(!showHide);
										}}
										className={classNames(classesCSStyles.editBtn)}>
										{showHide ? "HIDE" : "SHOW"}
									</div>
								</div>
							</GridItem>
						</GridContainer>
					</CardHeader>
					{showHide && (
						<CardBody className={classesCSStyles.accountSection}>
							<GridContainer className={classesCSStyles.py5}>
								<GridItem xs={12} sm={12} md={12}>
									{loading && (
										<Loading
											width={30}
											height={30}
											className={classesCSStyles?.absoluteLoading}
										/>
									)}
								</GridItem>
								{subscriptionList && (
									<>
										<GridItem
											xs={12}
											sm={9}
											md={9}
											className={classNames(classesCSStyles.marginAuto)}>
											<div className={classesCSStyles?.labelAc}>
												LICENSE-BASED SUBSCRIPTIONS
											</div>
										</GridItem>
										<GridItem
											xs={12}
											sm={3}
											md={3}
											className={classNames(classesCSStyles.marginAuto)}>
											<div
												className={classNames(
													classesCSStyles.py5,
													classesCSStyles.alignDiv
												)}>
												{userDetails?.canaddeditdelete && (
													<button
														type="button"
														disabled={account?.payway == "no" && account?.showpayway}
														onClick={addNewSubscription}
														className={classesCSStyles?.buttonPrimary}>
														Add New Subscription
													</button>
												)}

												{subscriptionData?.directcustomer &&
													subscriptionData?.subscriptions?.length > 0 && (
														<>
															&nbsp;
															<button
																type="button"
																onClick={() => {
																	setMoreInfo(!moreInfo);
																}}
																className={classesCSStyles?.buttonPrimary}>
																{moreInfo ? (
																	<Visibility className={classesCSStyles?.buttonIcon} />
																) : (
																	<VisibilityOff className={classesCSStyles?.buttonIcon} />
																)}
															</button>
														</>
													)}
											</div>
										</GridItem>
										<GridItem
											xs={12}
											sm={12}
											md={12}
											className={classNames(
												classes.mrAuto,
												classes.px5,
												loading ? classesCSStyles.loading : ""
											)}>
											<Table
												striped
												tableHead={tableHeader}
												tableData={extractLICENSE_BASED(subscriptionList)}
												customCellClasses={[
													classes.textLeft,
													classes.textLeft,
													classes.textLeft,
													classes.textLeft,
													classes.textLeft,
													classes.textLeft,
													classes.textLeft,
													classes.textLeft,
													classes.textLeft,
													classes.textLeft,
												]}
												customClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
												customHeadCellClasses={[
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
													classNames(
														classes.textLeft,
														classesCSStyles?.labelAc,
														classesCSStyles?.tableHeaderCell
													),
												]}
												customHeadClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
											/>
											{!loading &&
												(subscriptionList.length === 0 ||
													subscriptionList?.subscriptions?.length === 0) && (
													<div className={classNames(classesCSStyles?.my10)}>
														No License-based subscriptions found.
													</div>
												)}
										</GridItem>
									</>
								)}
							</GridContainer>
							{usageBasedSubscriptionList && !loading && (
								<GridContainer className={classesCSStyles.my10}>
									<GridItem
										xs={12}
										sm={12}
										md={12}
										className={classNames(
											classesCSStyles.marginAuto,
											classesCSStyles.py5
										)}>
										<div className={classesCSStyles?.labelAc}>
											USAGE-BASED SUBSCRIPTIONS
										</div>
									</GridItem>
									{usageBasedSubscriptionList?.list?.length > 0 && (
										<>
											<GridItem xs={12} sm={12} md={12} className={classesCSStyles.py5}>
												<div>
													<span className={classesCSStyles?.labelAc}>Report for: </span>
													{usageBasedSubscriptionList?.reportfor ?? "-"}
												</div>
												<div>
													<span className={classesCSStyles?.labelAc}>Billing Cycle: </span>
													{usageBasedSubscriptionList?.billingcycle ?? "-"}
												</div>
												<div>This customer have Usage-based subscriptions.</div>
											</GridItem>
											<GridItem xs={12} sm={4} md={4} className={classesCSStyles.py5}>
												<Table
													striped
													tableHead={["Subscription", "Quantity"]}
													tableData={extractUSAGE_BASED(usageBasedSubscriptionList?.list)}
													customCellClasses={[
														classes.textLeft,
														classes.textLeft,
														classes.textLeft,
													]}
													customClassesForCells={[0, 1, 2]}
													customHeadCellClasses={[
														classNames(
															classes.textLeft,
															classesCSStyles?.labelAc,
															classesCSStyles?.tableHeaderCell
														),
														classNames(
															classes.textLeft,
															classesCSStyles?.labelAc,
															classesCSStyles?.tableHeaderCell
														),
														classNames(
															classes.textLeft,
															classesCSStyles?.labelAc,
															classesCSStyles?.tableHeaderCell
														),
													]}
													customHeadClassesForCells={[0, 1, 2]}
												/>
											</GridItem>
										</>
									)}
								</GridContainer>
							)}
						</CardBody>
					)}
				</Card>
				{subscriptionDialogOpen && (
					<SubscriptionUpdateDialog
						subscriptionDialogOpen={subscriptionDialogOpen}
						setSubscriptionDialogOpen={setSubscriptionDialogOpen}
						geSubscriptionsData={geSubscriptionsData}
					/>
				)}
			</div>
			{accountAddDialog && (
				<AccountAddDialog
					accountAddDialog={accountAddDialog}
					setAccountAddDialog={setAccountAddDialog}
					emailPreviewData={emailPreviewData}
					setEmailPreview={setEmailPreview}
					setEmailPreviewData={setEmailPreviewData}
				/>
			)}
			{subscriptionReportDialog && (
				<SubscriptionReportDialog
					subscriptionReportDialog={subscriptionReportDialog}
					setSubscriptionReportDialog={setSubscriptionReportDialog}
				/>
			)}
			{emailPreview && (
				<EmailPreview
					emailPreview={emailPreview}
					setEmailPreview={setEmailPreview}
					emailPreviewData={emailPreviewData}
					setEmailPreviewData={setEmailPreviewData}
				/>
			)}
		</>
	);
};

export default SubscriptionDetails;
